// Widget Scripts
import headerCustomButtons from './js/widgets/headerCustomButtons.js';
import slideshow from './js/widgets/slideshow.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoImagesWidget from './js/widgets/seoImagesWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import customSignup from './js/widgets/customSignup.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/local.js';
import './js/siteInfoBanner.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  headerCustomButtons('customTicketButton', customTicketButtonOpts);
  headerCustomButtons('headerButton', headerButtonOpts);
  if (globalThis.location.pathname === '/') {
    slideshow();
    cardWidget();
    seoImagesWidget();
    seoWidget();
    customSignup();
    scrollerSponsors();
  }
});
